module.exports = __webpack_public_path__ + "static/media/1-item-b.5bfd880b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-b.jpg
// module id = 495
// module chunks = 33